import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import zIndex from "@material-ui/core/styles/zIndex";
import './style.css'
/*import logo from '../../assets/img/Triside-color-5.jpg'*/
import Fade from '@material-ui/core/Fade';
import Backdrop from "@material-ui/core/Backdrop";

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
        outline: 'none !important'
    };
}

const useStyles = makeStyles(theme => ({
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function InfoModal() {
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <button id="infoButton" style={{color: '#E53118', maxWidth:'250px', textAlign: 'center'}} type="button" onClick={handleOpen}>
                Informations
            </button>
            <Modal
                root={{overlay: {zIndex: '12'}}}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={open}
                onClose={handleClose}
                style={{outline:'none'}}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{ timeout: 500,}}
            >
                <Fade in={open}>
                <div id="modal" style={modalStyle} className={classes.paper}>
                    <a style={{float:"right", marginTop:"5px", color:"#E53118"}} width={"10px"} onClick={handleClose}><i className="material-icons" style={{float:"right", cursor:"pointer"}}>close</i></a>
                    {/*<img src={logo} width={'125vw'} alt={"logoTriside"}/>*/}
                    <h1>NewLine 1</h1>
                    <div className="redDivider"></div>
                    <h2>UN ESPACE DE VIE ÉTUDIÉ
                        POUR VOUS ET VOTRE FAMILLE</h2>
                    <div id="simple-modal-description">
                        {/*<div className="mail">
                            <h3>Email : </h3> <a href="mailto:feltes@feltes.lu"> feltes@feltes.lu</a>
                        </div>
                        <div className="tel">
                            <h3>Tél. : </h3> <span>+(352) 248 488 - 1</span>
                        </div>*/}
                        <p>
                            La sélection NewLine 2020 est une gamme originale,
                            signée Thomas & Piron.
                            <br/>
                            <br/>
                            Traditionnelles ou ossature bois, les maisons qui la
                            composent, offrent un confort de vie optimal, aux
                            caractéristiques énergétiques maîtrisées.
                            <br/>
                            <br/>
                            Ces projets qui évolueront au gré de vos besoins, de
                            vos envies et de votre budget constituent des bases
                            de réflexion efficaces auxquelles le candidat-bâtisseur
                            avisé ne restera pas insensible...
                        </p>
                    </div>
                </div>
                </Fade>
            </Modal>
        </div>
    );
}
